import * as types from './../constants/articleHeaderActionTypes';

export function requestArticleHeader(identifier, params) {
  return {type: types.ARTICLE_HEADER_LOAD_REQUEST, identifier, params};
}

export function requestArticleHeaderSuccess(articleHeader) {
  return {type: types.ARTICLE_HEADER_LOAD_SUCCESS, articleHeader};
}

export function requestArticleHeaderFailure(error) {
  return {type: types.ARTICLE_HEADER_LOAD_FAILURE, error};
}
